import styles from './ScannerBridgeStatusChip.module.css';
import type { ScannerBridgeState } from '../hooks/usePosScannerBridge';

function formatAgo(at: number | null, nowMs: number): string | null {
  if (!at) return null;
  const sec = Math.max(0, Math.round((nowMs - at) / 1000));
  if (sec < 5) return 'à l’instant';
  if (sec < 60) return `il y a ${sec}s`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `il y a ${min} min`;
  return `il y a ${Math.floor(min / 60)} h`;
}

export function ScannerBridgeStatusChip({
  state,
  nowMs,
}: {
  state: ScannerBridgeState;
  /** Bumped by parent so “il y a Xs” stays fresh. */
  nowMs: number;
}) {
  const { status, detail, lastCode, lastScanAt } = state;
  const ago = formatAgo(lastScanAt, nowMs);

  const label =
    status === 'ready'
      ? 'Lecteur prêt'
      : status === 'bridge'
        ? 'Pont actif'
        : 'Lecteur hors ligne';

  const titleParts = [
    label,
    detail ? detail : null,
    lastCode ? `Dernier scan ${lastCode}${ago ? ` (${ago})` : ''}` : null,
  ].filter(Boolean);

  return (
    <div
      className={styles.chip}
      data-status={status}
      title={titleParts.join(' — ')}
      role="status"
      aria-live="polite"
    >
      <span className={styles.dot} aria-hidden />
      <span className={styles.label}>{label}</span>
      {lastCode ? (
        <span className={styles.code} aria-label={`Dernier code ${lastCode}`}>
          {lastCode}
        </span>
      ) : null}
    </div>
  );
}
